export default __webpack_public_path__ + "static/media/KanzleiPilotLogoCollapse.c6b3c446.svg";